/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Regenerate_Switch_ModelInputs */



/**
* | output |
* | --- |
* | "Switch model" |
*
* @param {Chat_Regenerate_Switch_ModelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_regenerate_switch_model = /** @type {((inputs?: Chat_Regenerate_Switch_ModelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Regenerate_Switch_ModelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modell wechseln")
	return /** @type {LocalizedString} */ ("Switch model")
});